<script>
  export default {
    name: 'ConductInspectionItemUnknown',
  };
</script>

<template>
  <div>-</div>
</template>
